import { ShieldAlert } from "lucide-react";
import { Badge } from "../../components/Badge";
import type { MailWarning } from "../../api/types";

// 讀信時的警告(規格 §2.6「釣魚 / 危險附件警告」),判斷全在後端(`app/mailbox/warnings.py`):
//
// - 冒名(`impersonation`)、危險附件(`dangerous_attachment`)→ 紅色、`role="alert"`,文字是後端那一句。
// - 外部(`external`)→ 灰色小標,不是警告(客戶的信本來就是外部的,天天紅字等於沒有警告)。
// - 認不得的種類一律當紅色警告:寧可多提醒一次。

const RED = new Set(["impersonation", "dangerous_attachment"]);

export function isExternal(warnings: MailWarning[] | undefined): boolean {
  return (warnings ?? []).some((w) => w.kind === "external");
}

/** 小標(放在寄件人旁邊)。 */
export function ExternalBadge({ warnings }: { warnings: MailWarning[] | undefined }) {
  return isExternal(warnings) ? <Badge tone="neutral">外部</Badge> : null;
}

/** 紅色警告(放在信的最上面)。 */
export function MailWarnings({ warnings }: { warnings: MailWarning[] | undefined }) {
  const red = (warnings ?? []).filter((w) => w.kind !== "external" && (RED.has(w.kind) || w.text));
  if (red.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      {red.map((w, index) => (
        <p
          key={`${w.kind}-${index}`}
          role="alert"
          className="m-0 flex items-start gap-2 rounded-[var(--radius)] border border-[var(--danger)] bg-[var(--surface)] px-3 py-2 text-sm font-medium text-[var(--danger)]"
        >
          <ShieldAlert aria-hidden="true" size={16} className="mt-0.5 shrink-0" />
          <span className="min-w-0">{w.text}</span>
        </p>
      ))}
    </div>
  );
}
